import { Link } from "gatsby"
import React from "react"
import {
  YoutubeIconSolid,
  TwitterXIconSolid,
  FacebookIconSolid,
  LinkedinIconSolid,
  InstagramIconSolid,
} from "components/page-components/Icons/brands"

export const FooterHeroColumn = ({ title, link, paragraph, youtube }) => {
  return (
    <div className="column is-4">
      <div
        className="is-flex is-flex-direction-column"
        style={{ height: "100%" }}
      >
        {!!link ? (
          <Link
            to={link}
            className="title is-4 is-size-5-touch"
            dangerouslySetInnerHTML={{ __html: title }}
          ></Link>
        ) : (
          <div
            className="title is-4 is-size-5-touch"
            dangerouslySetInnerHTML={{ __html: title }}
          ></div>
        )}
        <p className="has-text-mitternachtsblau-30">{paragraph}</p>
        <div className="columns is-mobile is-variable is-2 mt-4">
          <div className="column is-narrow pl-0">
            <a
              href="https://de.linkedin.com/company/bimediengmbh"
              rel="noopener noreferrer"
              title={"B_I MEDIEN auf LinkedIn"}
            >
              <LinkedinIconSolid {...{ color: "#b3cbd4", size: 1 }} />
            </a>
          </div>

          <div className="column is-narrow ">
            <a
              href="https://www.youtube.com/user/biNewsPortal"
              rel="noopener noreferrer"
              title={"B_I MEDIEN (baufachzeitschriften) auf YouTube"}
            >
              <YoutubeIconSolid {...{ color: "#b3cbd4", size: 1 }} />
            </a>
          </div>

          <div className="column is-narrow ">
            <a
              href="https://twitter.com/bi_medien"
              rel="noopener noreferrer"
              title={"B_I MEDIEN auf X / Twitter"}
            >
              <TwitterXIconSolid {...{ color: "#b3cbd4", size: 1 }} />
            </a>
          </div>
          <div className="column is-narrow ">
            <a
              href="https://www.instagram.com/bimedien"
              rel="noopener noreferrer"
              title={"B_I MEDIEN auf Instagram"}
            >
              <InstagramIconSolid {...{ color: "#b3cbd4", size: 1 }} />
            </a>
          </div>
          <div className="column is-narrow pr-0">
            <a
              href="https://www.facebook.com/bimedien/"
              rel="noopener noreferrer"
              title={"B_I MEDIEN (baufachzeitschriften) auf Facebook"}
            >
              <FacebookIconSolid {...{ color: "#b3cbd4", size: 1 }} />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
